import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Library from "@/pages/Library";
import Player from "@/pages/Player";
import Vocabulary from "@/pages/Vocabulary";
import Review from "@/pages/Review";
import AIPractice from "@/pages/AIPractice";
import Statistics from "@/pages/Statistics";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Navigate to="/library" replace />} />
            <Route path="/library" element={<Protected><Library /></Protected>} />
            <Route path="/player/:videoId" element={<Protected><Player /></Protected>} />
            <Route path="/vocabulary" element={<Protected><Vocabulary /></Protected>} />
            <Route path="/review" element={<Protected><Review /></Protected>} />
            <Route path="/practice" element={<Protected><AIPractice /></Protected>} />
            <Route path="/statistics" element={<Protected><Statistics /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/library" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
